import { v1ServerByProjectAuth } from "server/index/serverInstances";
import { makeQuery } from "server/index/utils";
import {
  getAllMyNFTKitsRequest,
  getAllMyNFTKitsResponse,
  getMyKitsCategoryRequest,
  getMyKitsCategoryResponse,
} from "./index.type";

//유저가 생성한 모든 키트 조회
const getAllMyKits = async (
  request: getAllMyNFTKitsRequest
): Promise<getAllMyNFTKitsResponse> =>
  await v1ServerByProjectAuth.get({
    path: "/kits/me",
    query: makeQuery(request.query),
  });

const getMyKitsCategory = async (
  request: getMyKitsCategoryRequest
): Promise<getMyKitsCategoryResponse> =>
  await v1ServerByProjectAuth.get({
    path: "/kits/categories",
    query: makeQuery(request.query),
  });

export {
  getAllMyKits as getAllMyKitsFromServer,
  getMyKitsCategory as getMyKitsCategoryFromServer,
};
